import { Link } from "wouter";
import { Ticket } from "lucide-react";
import type { CSSProperties, MouseEvent } from "react";
import { BUY_TICKETS_LABEL, ticketsHref } from "@/lib/eventCta";

/** CHI-22: the single "Buy Tickets" CTA, a link to /events/:slug/tickets. */
export default function BuyTicketsButton({
  slug,
  className = "chi-btn-primary",
  style,
  iconSize = 16,
  onClick,
}: {
  slug: string;
  className?: string;
  style?: CSSProperties;
  iconSize?: number;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}) {
  return (
    <Link
      href={ticketsHref(slug)}
      className={className}
      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", textDecoration: "none", ...style }}
      data-testid="buy-tickets"
      onClick={onClick}
    >
      <Ticket size={iconSize} aria-hidden="true" /> {BUY_TICKETS_LABEL}
    </Link>
  );
}
